const CHANGES_LOG = 'CHANGES_LOG';


const ChangesLog = (changes) => ({
    type: CHANGES_LOG,
    payload: {
        changes: changes,
    },
});

export {
    CHANGES_LOG,
    ChangesLog
}